import * as React from "react"
import type { SVGProps } from "react"
const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 19.64a28 28 0 0 0 4.53-5.1Q18 12.27 18 10.5q0-2.72-1.74-4.47C14.52 4.27 13.68 4.3 12 4.3a5.8 5.8 0 0 0-4.26 1.73A6 6 0 0 0 6 10.5q0 1.77 1.48 4.06 1.47 2.28 4.52 5.09m0 1.97q-.35 0-.7-.12a2 2 0 0 1-.62-.38A39 39 0 0 1 7.8 18.2a22 22 0 0 1-2.09-2.77q-.84-1.34-1.27-2.57A7 7 0 0 1 4 10.49Q4 6.74 6.41 4.5 8.82 2.3 12 2.3c3.18 0 3.98.74 5.59 2.22q2.4 2.22 2.41 5.98 0 1.12-.44 2.36-.43 1.23-1.27 2.57a22 22 0 0 1-2.09 2.77 39 39 0 0 1-2.87 2.92 2 2 0 0 1-.63.38 2 2 0 0 1-.7.12m0-9.32q.83 0 1.41-.6.6-.57.59-1.4 0-.82-.59-1.42A2 2 0 0 0 12 8.3q-.83 0-1.41.58A2 2 0 0 0 10 10.3q0 .83.59 1.4.58.6 1.41.6" />
  </svg>
)
export default SvgMapPin
